// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************

let myStore = {};

// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Splide
// =====================================================================================================================

import Splide from '@splidejs/splide';


// Apply Class After scrolling the page a specific amount
function toggleClassOnScroll(pixelAmount, target,  className) {
	const el = typeof target === "string" ? document.querySelector(target) : target;
	if (!el) {
		console.warn("Target element not found:", target);
		return;
	}

	function update() {
		if (window.scrollY > pixelAmount) {
			el.classList.add(className);
		} else {
			el.classList.remove(className);
		}
	}

	// Run on page load
	update();

	// Run on scroll
	window.addEventListener("scroll", update);
}
toggleClassOnScroll(130, "body", "site-scrolled");


// Helper functions to set javascript cookies
function setCookie(name, value, days) {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	// Encode the value to handle special characters
	document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
}

function deleteCookie(name, path, domain) {
	// Set the value to empty and the expiration to a past date.
	// The date Thu, 01 Jan 1970 00:00:00 UTC is a standard choice.
	document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;" +
		(domain ? "; domain=" + domain : "") +
		(path ? "; path=" + path : "; path=/"); // Default to root path if none specified.
}

function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for(let i=0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
	}
	return null; // Return null if the cookie is not found
}


// Get all collapse-trigger class items and set data attribute for Bootstrap collapse
const collapseTriggers = document.querySelectorAll('#wrapper-navbar .collapse-trigger');
collapseTriggers.forEach(element => {
	const anchor = element.querySelector('a');
	const target = anchor.getAttribute('href').slice(1);
	if (anchor) {
		anchor.setAttribute('data-bs-toggle', 'collapse');
		anchor.setAttribute('role', 'button');
		anchor.setAttribute('aria-controls', target);
	}else{
		element.setAttribute('data-bs-toggle', 'collapse');
		element.setAttribute('role', 'button');
		element.setAttribute('aria-controls', target);
	}
});


// Close Modal on click of targeted buttons
const closeModalButtons = document.querySelectorAll('.close-modal-button');
closeModalButtons.forEach(element => {
	element.addEventListener('click', function(event) {
		let modalClose = element.closest('.modal-content').querySelector('.btn-close');
		modalClose.click();
	});
});


// Prevent scroll on specific dropdowns
var mobileMenu = document.getElementById('mobileMenu');
var inventoryDropdown = document.getElementById('inventoryDropdown');
mobileMenu.addEventListener('show.bs.collapse', function () {
	document.body.classList.add('no-scroll');
});
mobileMenu.addEventListener('hide.bs.collapse', function () {
	if( inventoryDropdown.classList.contains('show') ) {
		document.querySelector('#mobileInventoryBackBtn a').click();
	}
	document.body.classList.remove('no-scroll');
});
inventoryDropdown.addEventListener('show.bs.collapse', function () {
	if (window.innerWidth < 992) {
		document.body.classList.add('no-scroll');
	}
});
inventoryDropdown.addEventListener('hide.bs.collapse', function () {
	if (window.innerWidth < 992) {
		document.body.classList.remove('no-scroll');
	}
});



// Move all Modal Window elements to the body root
document.addEventListener('DOMContentLoaded', function() {
	const modalElements = document.querySelectorAll('.modal');

	modalElements.forEach(modal => {
		document.body.appendChild(modal);
	});
});


// Bootstrap Tooltip Enabling
jQuery(function () {
	jQuery('[data-toggle="tooltip"]').tooltip();
})

jQuery(document).on('facetwp-loaded', function() {
	// Reinitialize Bootstrap tooltips
	jQuery('[data-toggle="tooltip"]').tooltip();
});


// Location Setting Functionality
document.addEventListener('DOMContentLoaded', function() {
	// Get content for Location setting dropdown
	fetch("/wp-content/themes/epicstrap/user-location-dropdown.php", {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded"
		},
		body: ""
	})
		.then(response => response.text())
		.then(data => {
			//console.log(data);

			// Set Dropdown content
			document.getElementById('locationSelector').innerHTML = data;

			// Click event after Dropdown content is set
			document.querySelectorAll("#locationSelector .dropdown-item").forEach(function (el) {
				el.addEventListener("click", function (e) {
					e.preventDefault();
					const store_id = this.id;
					const store_name = this.innerText;
					const store_city = this.getAttribute('data-city');
					const store_state = this.getAttribute('data-state');
					const store_zip = this.getAttribute('data-zip');
					const store_lat = this.getAttribute('data-lat');
					const store_long = this.getAttribute('data-long');
					const store_phone = this.getAttribute('data-phone');
					const store_takestock = this.getAttribute('data-takestock');

					if (store_id == 'clearLocation') {
						deleteCookie("magnum_location_id", "/");
						deleteCookie("magnum_location_name", "/");
						deleteCookie("magnum_location_city", "/");
						deleteCookie("magnum_location_state", "/");
						deleteCookie("magnum_location_zip", "/");
						deleteCookie("magnum_location_lat", "/");
						deleteCookie("magnum_location_long", "/");
						deleteCookie("magnum_location_phone", "/");
						deleteCookie("magnum_location_takestock_id", "/");

						window.location.reload();
					} else {
						setCookie('magnum_location_id', store_id, 30);
						setCookie('magnum_location_name', store_name, 30);
						setCookie('magnum_location_city', store_city, 30);
						setCookie('magnum_location_state', store_state, 30);
						setCookie('magnum_location_zip', store_zip, 30);
						setCookie('magnum_location_lat', store_lat, 30);
						setCookie('magnum_location_long', store_long, 30);
						setCookie('magnum_location_phone', store_phone, 30);
						setCookie('magnum_location_takestock_id', store_takestock, 30);

						window.location.reload();
					}
				});
			});

			// Set phone number if cookie exists
			if (getCookie('magnum_location_phone') !== null) {
				document.getElementById('navPhoneNumber').innerHTML = getCookie('magnum_location_phone');
				document.getElementById('navPhoneNumber').href = 'tel:' + getCookie('magnum_location_phone');
			}
		})
		.catch(error => console.error("Error:", error))
});

document.addEventListener('click', function(event) {
	if (event.target.classList.contains('location-clear-btn')) {
		event.preventDefault();

		deleteCookie('magnum_location_id', "/");
		deleteCookie('magnum_location_name', "/");
		deleteCookie("magnum_location_city", "/");
		deleteCookie("magnum_location_state", "/");
		deleteCookie("magnum_location_zip", "/");
		deleteCookie("magnum_location_lat", "/");
		deleteCookie("magnum_location_long", "/");
		deleteCookie('magnum_location_phone', "/");
		deleteCookie('magnum_location_takestock_id', "/");

		window.location.reload();
	}
});


// Initialize Splide on Inventory Cards
function inventoryCardSplide(target) {
	new Splide(target, {
		type: 'slide',
		pagination: true,
		arrows: false,
		drag: true,
		gap: '25px',
		perPage: 1,
		breakpoints: {
			768: {
				perPage: 1
			},
			1100: {
				perPage: 1
			},
		}
	}).mount();
}

// Open Accordions if their filter is applied
function openFilterAccordions(){
	let activeFilters = document.querySelectorAll('.facetwp-selections [data-facet]');
	activeFilters.forEach(filter => {
		const facetName = filter.getAttribute('data-facet')
			|| filter.closest('[data-facet]')?.getAttribute('data-facet');
		if (!facetName) return;

		let facetFound = document.querySelector(`.facetwp-facet[data-name="${CSS.escape(facetName)}"]`);
		if(facetFound) {
			let nearestAccordionButton = facetFound.closest('.accordion-item').querySelector('.accordion-button');
			nearestAccordionButton.click();
		}
	});
}
document.addEventListener('DOMContentLoaded', () => setTimeout(openFilterAccordions, 0));


// Remove empty accordions with no Facet options
function removeEmptyAccordions(){
	let accordions = document.querySelectorAll('#filterAccordionsAccordion');
	accordions.forEach(accordion => {
		let accordionItems = accordion.querySelectorAll('.accordion-item');
		accordionItems.forEach(item => {
			let facetOptions = item.querySelectorAll('.facetwp-facet');
			console.log(facetOptions);
			if(facetOptions.length === 0) {
				//item.remove();
			}
		})
	})
}


// Update Range Inputs Fill Percentage Variable
function setPercentageVar(target) {
	const value = (target.value - target.min) / (target.max - target.min) * 100;
	target.style.setProperty('--fill-percentage', `${value}%`);
}
function updateRangeInputs() {
	let rangeInputs = document.querySelectorAll('input[type="range"]');
	rangeInputs.forEach(function (input) {
		setPercentageVar(input);
		input.addEventListener('input', function () {
			setPercentageVar(this);
		});
	});
}
document.addEventListener('DOMContentLoaded', () => setTimeout(updateRangeInputs, 0));


// Trigger on Facet Load
document.addEventListener('facetwp-loaded', function() {
	document.querySelectorAll('.card-slider').forEach(function (slider) {
		if(!slider.classList.contains('is-initialized')) {
			inventoryCardSplide('#' + slider.id);
		}
	});
	updateRangeInputs();
	//removeEmptyAccordions();
});

// Debug: confirm refresh event is firing
document.addEventListener('facetwp-refresh', () => {
	//console.log('[facetwp-refresh] is_refresh:', FWP.is_refresh, 'facets:', JSON.stringify(FWP.facets));

	let proximityName = 'proximity';
	let locationName = 'location';

	if ( null !== FWP.active_facet && proximityName == fUtil(FWP.active_facet.nodes[0]).attr('data-name') ) {
		// Check if the proximity facet actually has a value (is not empty)
		if ( '' !== FWP.facets[proximityName] ) {
			FWP.facets[locationName] = []; // Reset the target facet
		}
	}

	// Only run on inventory page
	if (!document.getElementById('inventoryScroll')) return;

	// Prevent infinite loops across FacetWP refresh cycles
	if (window.__magnum_location_preset_done) return;

	const lat = parseFloat(getCookie('magnum_location_lat'));
	const long = parseFloat(getCookie('magnum_location_long'));
	const city = getCookie('magnum_location_city');
	const state = getCookie('magnum_location_state');
	const zip = getCookie('magnum_location_zip');
	const location = city + ', ' + state + ' ' + zip + ', USA';
	if (!lat || !long || !location) return;

	// Only apply if proximity isn't already meaningfully set
	const current = FWP.facets.proximity || [];
	const alreadySet = current.length >= 3 && Number.isFinite(parseFloat(current[0])) && Number.isFinite(parseFloat(current[1]));
	if (alreadySet) return;

	window.__magnum_location_preset_done = true;
	FWP.facets.proximity = [lat, long, 25, location];

	FWP.setHash();
	FWP.fetchData();
	FWP.refresh();
});

document.addEventListener('facetwp-loaded', () => {
	//console.log('[facetwp-loaded] is_refresh:', FWP.is_refresh, 'facets:', JSON.stringify(FWP.facets));
});


// Trigger on Page Load
document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.card-slider').forEach(function (slider) {
		if(!slider.classList.contains('is-initialized')) {
			inventoryCardSplide('#' + slider.id);
		}
	});

	// --------------------- Form Assembly Presets on Page Load ---------------------
	// Set Form ID
	let contactForm = false;
	let availabilityForm = false;
	if (window.location.hostname.includes('magnumtrailers.com')) {
		contactForm = document.getElementById('165');
		availabilityForm = document.getElementById('161');
	}else if(window.location.hostname.includes('magnumtraildev.wpenginepowered.com')){
		contactForm = document.getElementById('164');
		availabilityForm = document.getElementById('163');
	}

	// Set Takestock ID field
	if(contactForm && contactForm.querySelector('#tfa_37')){
		if (getCookie('magnum_location_takestock_id') !== null) {
			contactForm.querySelector('#tfa_37').value = getCookie('magnum_location_takestock_id');
		}else{
			contactForm.querySelector('#tfa_37').value = '401';
		}
	}
	// Set field for url of current page
	if(contactForm && contactForm.querySelector('#tfa_47')){
		contactForm.querySelector('#tfa_47').value = window.location.href;
	}
	if(availabilityForm && availabilityForm.querySelector('#tfa_47')){
		availabilityForm.querySelector('#tfa_47').value = window.location.href;
	}
	// Set Domain field for redirecting
	if(contactForm && contactForm.querySelector('#tfa_50')){
		contactForm.querySelector('#tfa_50').value = 'https://' + window.location.hostname;
	}
	if(availabilityForm && availabilityForm.querySelector('#tfa_58')){
		availabilityForm.querySelector('#tfa_58').value = 'https://' + window.location.hostname;
	}
});


// Locations Page Directions buttons
function locatorButtons(targetSelector, newClass, prependText) {
	const callback = function(mutationsList) {
		mutationsList.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === 1) { // Ensure it's an element
					if (node.matches(targetSelector)) {
						// Add class
						node.classList.add(newClass);
						// Prepend text
						node.innerHTML = prependText + node.innerHTML;
					}

					// Also check descendants
					node.querySelectorAll(targetSelector).forEach(el => {
						el.classList.add(newClass);
						el.innerHTML = prependText + el.innerHTML;
					});
				}
			});
		});
	};
	const observer = new MutationObserver(callback);

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}
locatorButtons('#wpsl-stores .wpsl-directions', 'orange-btn', '<img src="https://magnumtraildev.wpenginepowered.com/wp-content/themes/epicstrap/assets/fork_right.svg" alt=""> Get ');


// Custom Home Search Functionality
document.addEventListener('DOMContentLoaded', function() {
	const searchInput = document.getElementById('homeSearch');
	if (searchInput) {
		const hiddenBtn = document.getElementById('searchFocusBtn');
		const targetCollapse = document.getElementById('searchFocusCollapse');
		searchInput.addEventListener('focus', function() {
			if (targetCollapse && !targetCollapse.classList.contains('show')) {
				hiddenBtn.click();
			}
		});
	}
});

let homeForm = document.getElementById('homeSearchForm');
if (homeForm) {
	homeForm.addEventListener('submit', function () {
		let allInputs = homeForm.getElementsByTagName('input');

		for (let i = 0; i < allInputs.length; i++) {
			let input = allInputs[i];
			if (input.name && !input.value) {
				input.name = '';
			}
		}
	});
}

const homeSearchFilters = document.getElementById('searchFiltersCollapse');
if (homeSearchFilters) {
	homeSearchFilters.querySelectorAll('.facetwp-type-checkboxes').forEach(function (checkboxes) {
		let inputTarget = document.getElementsByName(checkboxes.getAttribute('data-name'));
		checkboxes.querySelectorAll('.facetwp-checkbox').forEach(function (checkbox) {
			checkbox.addEventListener('click', function () {
				let values = Array.from(checkboxes.querySelectorAll(".checked") ).map(
					checkbox => checkbox.getAttribute('data-value')
				);
				if(checkbox.classList.contains('checked')) {
					checkbox.classList.remove('checked');
					values = values.filter(value => value !== checkbox.getAttribute('data-value'));
					inputTarget[0].value = values.join(',');
				}else{
					checkbox.classList.add('checked');
					values.push( checkbox.getAttribute('data-value') );
					inputTarget[0].value = values.join(',');
				}
			});
		});
	});
	homeSearchFilters.querySelectorAll('.facetwp-type-dropdown').forEach(function (dropdowns) {
		let inputTarget = document.getElementsByName(dropdowns.getAttribute('data-name'));
		dropdowns.querySelectorAll('.facetwp-dropdown').forEach(function (dropdown) {
			dropdown.addEventListener('change', function () {
				inputTarget[0].value = this.value;
			})
		})
	});
}


// Check Availability modal functionality
document.addEventListener('click', function(event) {
	if (event.target.classList.contains('check-avail-btn')) {
		event.preventDefault();

		let button = event.target;
		let modalElement = document.getElementById('checkAvailabilityModal');
		let form = modalElement.querySelector('form');
		let trailer = button.dataset.trailer;
		let dealer = button.dataset.dealer;
		let vin = button.dataset.vin;
		let page = window.location.href;

		form.querySelector('#tfa_37').value = dealer;
		form.querySelector('#tfa_52').value = trailer;
		form.querySelector('#tfa_54').value = trailer;
		form.querySelector('#tfa_50').value = vin;
		form.querySelector('#tfa_47').value = page;
	}
});

var BTTW = (function(BTTW, $) {
	$(document).ready(function(){
		// Promotions S Curve
		let promoCount = 0;
		$('#promotionsWrapper .promo-card').each(function(){
			if(promoCount % 2 !== 0){
				$(this).find('.row').addClass('flex-row-reverse');
			}
			promoCount++;
		});

		// Inventory Filters Show/Hide
		$('#filterTrigger a').on('click', function(e){
			e.preventDefault();
			if( !$(this).hasClass('closed') ){
				$('#inventoryScroll .filters-column').addClass('d-none');
				$('#inventoryScroll .results-column').addClass('w-100');
				$(this).html($(this).html().replace(/Hide/g, 'Show'));
				$(this).addClass('closed');
			}else{
				$('#inventoryScroll .filters-column').removeClass('d-none');
				$('#inventoryScroll .results-column').removeClass('w-100');
				$(this).html($(this).html().replace(/Show/g, 'Hide'));
				$(this).removeClass('closed');
			}
		});

		if($('.pdp-slider-wrapper .splide').length){
			const saveHeight = document.querySelector('.pdp-main-info').offsetHeight - 1;

			// Observer to trigger new styles when inventory sticky nav starts to follow you down the page
			const pdpStickyNav = document.querySelector('#pdpStickyNavSensor');
			const pdpStickyNavObs = new IntersectionObserver(([e]) => {
					const ratio = e.intersectionRatio;
					if (e.boundingClientRect.top > 0 || ratio > 0) { // Below
						pdpStickyNav.style.height = '0px';
						document.querySelector('.pdp-main-info').classList.remove('isSticky');
					}else{ // Above
						document.querySelector('.pdp-main-info').classList.add('isSticky');
						pdpStickyNav.style.height = `${saveHeight}px`;
					}
				}, {
					rootMargin: `0px 0px 0px 0px`,
					threshold: [...Array(100).keys()].map(x => x / 100)
				}
			);
			pdpStickyNavObs.observe(pdpStickyNav);

			// New PDP page gallery slider
			let mainPDPSlider = new Splide( '.pdp-slider-wrapper .splide', {
				type   : 'loop',
				arrows: true,
				pagination : false,
				drag: true,
				gap: '25px',
				perPage: 3,
				focus  : 'center',
				breakpoints: {
					768: {
						perPage: 1,
						drag: true
					},
					1080: {
						perPage: 2,
						drag: true
					},
				}
			} );
			mainPDPSlider.mount();

			// Update slider count tag in Gallery
			if($('.pdp-slider-wrapper .splide .slide-counter').length > 0){
				$('.pdp-slider-wrapper .splide .slide-counter .count').html(mainPDPSlider.index + 1);
				$('.pdp-slider-wrapper .splide .slide-counter .total').html(mainPDPSlider.length);
				mainPDPSlider.on( 'move', function () {
					$('.pdp-slider-wrapper .splide .slide-counter .count').html(mainPDPSlider.index + 1);
				});
			}
		}

		// Mobile Related Products slider
		if($('.pdp-features-section .splide').length){
			var productFeaturesSlider = new Splide( '.pdp-features-section .splide', {
				type   : 'slide',
				pagination : true,
				arrows: true,
				drag: false,
				gap: '25px',
				perPage: 3,
				perMove: 1,
				breakpoints: {
					768: {
						perPage: 1,
						drag: true,
						arrows: true,
						pagination: true
					},
					1100: {
						perPage: 2,
						drag: true,
						arrows: true,
						pagination: true
					},
				}
			} );
			productFeaturesSlider.mount();
		}

		// Mobile Related Products slider
		if($('.pdp-related-wrapper .splide').length){
			var relatedPDPSlider = new Splide( '.pdp-related-wrapper .splide', {
				type   : 'loop',
				pagination : false,
				arrows: false,
				drag: false,
				gap: '25px',
				perPage: 3,
				breakpoints: {
					768: {
						perPage: 1,
						drag: true,
						arrows: true,
						focus: 'center',
						pagination: true
					},
					1100: {
						perPage: 1.5,
						drag: true,
						arrows: true,
						focus: 'center',
						pagination: true
					},
				}
			} );
			relatedPDPSlider.mount();
		}

		// Promo Tag functionality on new PDP page
		$('.promo-flag .promo-wrapper').on('click', function(e){
			if( $(this).hasClass('closed') ){
				$(this).addClass('open').removeClass('closed');
			}else{
				$(this).removeClass('open').addClass('closed');
			}
		});

		// Reset iframe on modal close to stop the video
		const videoModal = document.getElementById('videoModal');
		if(videoModal !== null){
			videoModal.addEventListener('hide.bs.modal', event => {
				$(this).find('.modal').find('iframe').each(function( index ) {
					$(this).attr('src', $(this).attr('src'));
				});
			});
		}

		// Highlights show more functionality
		$('.view-more-btn').on('click', function(e){
			e.preventDefault();
			$(this).parent().find('.d-none').removeClass('d-none');
			$(this).hide();
		});

		// Calculate the Estimated Monthly Payment
		function empFormCalc(){
			var financeAmount = parseInt($('#pdpEstimateForm #amount').val().replace(/[$,]/g, ""));
			var apr = (parseFloat($('#pdpEstimateForm #apr').val())/100)/12;
			var termLength = parseInt($('#pdpEstimateForm #term').val());
			var adjustment = parseFloat(apr) * Math.pow( (1 + parseFloat(apr)), termLength );
			var adjustmentTwo = Math.pow( (1 + parseFloat(apr)), termLength ) - 1;

			var monthlyPayment = parseInt(financeAmount) * (adjustment / adjustmentTwo);
			var currencyFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
			$('#estimatedPayment').html('$'+currencyFormat.format(monthlyPayment.toFixed(2)));
		}

		// Update Down Payment when range updates
		$('#pdpEstimateForm #downPaymentRange').on('input', function(e){
			var currencyFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 });
			var fullAmount = $('#pdpEstimateForm #fullAmount').val().replace(/[$,]/g, "");
			var newFinance = parseInt(fullAmount) - parseInt(e.target.value);

			$('#pdpEstimateForm #downPayment').val(e.target.value);
			$('#pdpEstimateForm #amount').val('$'+currencyFormat.format(newFinance));
			$('#pdpEstimateForm #downPayment').trigger('change');
			empFormCalc();
		});
		// Updates range slider when input is changed
		$('#pdpEstimateForm #downPayment').on('input', function(e){
			var currencyFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 });
			var fullAmount = $('#pdpEstimateForm #fullAmount').val().replace(/[$,]/g, "");
			var newFinance = parseInt(fullAmount) - parseInt(e.target.value);

			$('#pdpEstimateForm #downPaymentRange').val(e.target.value);
			$('#pdpEstimateForm #amount').val(newFinance).text('$'+currencyFormat.format(newFinance));
			empFormCalc();
		});
		// Update Term Lengths based on loan amount
		$('#pdpEstimateForm #downPayment').on('change', function(e){
			var financeAmount = parseInt($('#pdpEstimateForm #amount').val().replace(/[$,]/g, ""));

			var newOptions = {};
			if(financeAmount >= 3000 && 10000 > financeAmount){
				newOptions['36'] = '36 months';
				newOptions['48'] = '48 months';
			}
			if(financeAmount >= 5000){
				newOptions['60'] = '60 months';
			}
			if(financeAmount >= 10000){
				newOptions['72'] = '72 months';
				newOptions['84'] = '84 months';
			}

			$('#pdpEstimateForm #term').empty(); // remove old options
			$.each(newOptions, function(key,value) {
				$('#pdpEstimateForm #term').append($("<option></option>").attr("value", key).text(value));
			});
			$("#pdpEstimateForm #term option:first").prop("selected", true);
			$('#pdpEstimateForm #term').trigger('input');
		});
		// Change APR value on Term Length change
		$('#pdpEstimateForm #term').on('input', function(e){
			var apr = $('#pdpEstimateForm #apr').val();
			switch(e.target.value) {
				case '36':
					apr = "8.49%";
					break;

				case '48':
					apr = "9.74%";
					break;

				case '60':
					apr = "10.74%";
					break;

				case '72':
					apr = "11.74%";
					break;

				case '84':
					apr = "12.24%";
					break;

				default:
					break;
			}
			$('#pdpEstimateForm #apr').attr('value', apr);
			empFormCalc();
		});
	});
// END of New PDP Page Functionality EPIC Creative ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	return BTTW;
}(BTTW || {}, jQuery));